@if (employeeTaxFormsTables(); as employeeTaxFormsTables) {
    <ui-card class="tax-forms" [withMargin]="false" [withSpacing]="false">
        <app-segment-header class="margin-x-4 margin-top-4" title="payroll.taxReturns.employeeTaxForms" />
        @if (employeeTaxFormsTables.RL1) {
            <app-child-tab-bar (onTabChange)="currentTaxFormsTab = $event">
                <app-child-tab [initiallyActive]="true" value="T4">{{
                    'table.employeeTaxForms.T4.type' | translate
                }}</app-child-tab>
                <app-child-tab value="RL1">{{ 'table.employeeTaxForms.RL1.type' | translate }}</app-child-tab>
            </app-child-tab-bar>
        }
        @for (table of employeeTaxFormsTables | keyvalue; track table.key) {
            @if (table.value && currentTaxFormsTab === table.key) {
                <app-table
                    [table]="table.value"
                    (menuItemSelected)="employeeTaxFormEvent.emit($event)"
                    [useStickyActions]="true"
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                >
                    <div class="buttons">
                        <!-- Amendment Button -->
                        <ng-container
                            [ngTemplateOutlet]="amendmentButton"
                            [ngTemplateOutletContext]="{ summary: table.key === 'RL1' ? rl1Summary() : t4Summary() }"
                        />
                        <!-- Preview Tax Forms Button 
                         
                        Appears as a single button if preview is only available for one form type, or as a dropdown if preview is available for both form types.
                        In the case of the single button, we only display it if the user is on the corresponding form tab.
                        -->
                        @if (
                            previewableTaxPackages().length > 1 || previewableTaxPackages()[0] === currentTaxFormsTab
                        ) {
                            <ui-button
                                type="outline"
                                [matMenuTriggerFor]="previewableTaxPackages().length > 1 ? previewMenu : null"
                                #previewMenuTrigger="matMenuTrigger"
                                (click)="
                                    previewableTaxPackages().length > 1
                                        ? undefined
                                        : downloadPreview.emit([currentTaxFormsTab])
                                "
                                >{{ 'table.employeeTaxForms.downloadPreview' | translate }}
                                @if (previewableTaxPackages().length > 1) {
                                    <mat-icon
                                        class="margin-left-1"
                                        [svgIcon]="previewMenuTrigger?.menuOpen ? 'chevronUp' : 'chevronDown'"
                                    />
                                }
                            </ui-button>
                        }
                        <!-- Send Tax Form Emails Button
                        
                        Follows the same display logic as the preview button above.
                        -->
                        @if (sendableTaxPackages().length > 1 || sendableTaxPackages()[0] === currentTaxFormsTab) {
                            <ui-button
                                type="primary"
                                [matMenuTriggerFor]="sendableTaxPackages().length > 1 ? emailMenu : null"
                                [disabled]="
                                    sendableTaxPackages().length === 1 &&
                                    sendableTaxPackages()[0] === 'RL1' &&
                                    !rl1Summary()?.canSendEmails
                                "
                                [matTooltip]="
                                    sendableTaxPackages().length === 1 &&
                                    sendableTaxPackages()[0] === 'RL1' &&
                                    !rl1Summary()?.canSendEmails
                                        ? ('payroll.taxForms.RL1.cannotSend' | translate)
                                        : undefined
                                "
                                #emailMenuTrigger="matMenuTrigger"
                                (click)="
                                    sendableTaxPackages().length > 1
                                        ? undefined
                                        : sendFormsToEmployees.emit([currentTaxFormsTab])
                                "
                                >{{ 'table.employeeTaxForms.sendFormsToEmployees' | translate }}
                                @if (sendableTaxPackages().length > 1) {
                                    <mat-icon
                                        class="margin-left-1"
                                        [svgIcon]="emailMenuTrigger?.menuOpen ? 'chevronUp' : 'chevronDown'"
                                    />
                                }
                            </ui-button>
                        }
                    </div>
                    <app-empty-state
                        [label]="'payroll.taxReturns.taxFormsWillAppearHereWhenTheTaxPackagesHaveBeenGenerated'"
                    ></app-empty-state>
                </app-table>
            }
        }
    </ui-card>
}

<ng-template #amendmentButton let-summary="summary">
    @if (summary.isAmendment && summary.isOpen) {
        <ui-button type="primary" (click)="addAmendedTaxForm.emit()">{{
            'payroll.taxForms.addAmendedTaxForm' | translate
        }}</ui-button>
    }
</ng-template>

<mat-menu #previewMenu xPosition="after">
    <button mat-menu-item (click)="downloadPreview.emit(['T4', 'RL1'])">
        {{ 'table.employeeTaxForms.previewAll' | translate }}
    </button>
    <button mat-menu-item (click)="downloadPreview.emit(['T4'])">
        {{ 'table.employeeTaxForms.T4.preview' | translate }}
    </button>
    <button mat-menu-item (click)="downloadPreview.emit(['RL1'])">
        {{ 'table.employeeTaxForms.RL1.preview' | translate }}
    </button>
</mat-menu>

<mat-menu #emailMenu xPosition="after">
    <!-- When RL-1s are in a processing/pending state we show a tooltip and disable emailing until we get confirmation from RQ-->
    <button
        mat-menu-item
        (click)="sendFormsToEmployees.emit(['T4', 'RL1'])"
        [disabled]="!rl1Summary()?.canSendEmails"
        [matTooltip]="rl1Summary()?.canSendEmails ? undefined : ('payroll.taxForms.RL1.cannotSend' | translate)"
        matTooltipPosition="before"
    >
        {{ 'table.employeeTaxForms.sendAll' | translate }}
    </button>
    <button mat-menu-item (click)="sendFormsToEmployees.emit(['T4'])">
        {{ 'table.employeeTaxForms.T4.send' | translate }}
    </button>
    <button
        mat-menu-item
        (click)="sendFormsToEmployees.emit(['RL1'])"
        [disabled]="!rl1Summary()?.canSendEmails"
        [matTooltip]="rl1Summary()?.canSendEmails ? undefined : ('payroll.taxForms.RL1.cannotSend' | translate)"
        matTooltipPosition="before"
    >
        {{ 'table.employeeTaxForms.RL1.send' | translate }}
    </button>
</mat-menu>
